import fetchPonyfill from 'fetch-ponyfill';
import Immutable from 'immutable';
import queryString from 'query-string';
import {defaults as defaultOptions} from 'store/config/reducer';

export const {fetch} = fetchPonyfill();

// Helpers

const getApiConfig = () => {
    const qs = queryString.parse(window.location.search);
    return {url: qs.apiUrl, token: qs.apiToken};
};

export const isConfigurationsApiEnabled = () => {
    const config = getApiConfig();
    return Boolean(config.url) && Boolean(config.token);
};

const getApiUrl = id => {
    const config = getApiConfig();
    const url = id ? `${config.url}/${id}/` : `${config.url}/`;
    return `${url}?api_token=${config.token}`;
};

// API

export const loadConfigurations = () => new Promise((resolve) => (
    fetch(getApiUrl())
        .then(response => response.json())
        .then(configurations => (
            resolve(Immutable.fromJS(configurations.map(configuration => ({
                id: configuration.id,
                name: configuration.name,
                values: {...defaultOptions.merge(JSON.parse(configuration.values)).toJS()},
            }))))
        ))
));

export const createConfiguration = payload => new Promise((resolve) => {
    const body = new FormData();
    body.append('api_token', getApiConfig().token);
    body.append('name', payload.name);
    body.append('values', JSON.stringify(payload.values));
    return fetch(getApiUrl(), {method: 'POST', body})
        .then(response => response.json())
        .then(configuration => resolve(Immutable.fromJS(configuration)));
});

export const updateConfiguration = payload => new Promise((resolve) => {
    const body = new FormData();
    body.append('api_token', getApiConfig().token);
    body.append('values', JSON.stringify(payload.values));
    return fetch(getApiUrl(payload.id), {method: 'PATCH', body})
        .then(response => response.json())
        .then(configuration => resolve(Immutable.fromJS(configuration)));
});

export const deleteConfiguration = payload => new Promise((resolve) => (
    fetch(getApiUrl(payload.id), {method: 'DELETE'})
        .then(() => resolve(null))
));



// WEBPACK FOOTER //
// ./scripts/test-page/api.js